import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//- material
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import DeleteIcon from '@material-ui/icons/Delete';

//- local
import SupplierContainer from '../../containers/logistics/Supplier';
import FMPTextField from '../../components/ui/FMPTextField';
import Contacts from '../../components/form/Contacts';
import FMPQuickbooksVendorSelect from '../../components/pureForm/FMPQuickbooksVendorSelect';

const styles = (theme) => {
	const primaryColor = theme.palette.primary[500];
	return {
		note: {
			fontSize: 14,
			color: '#666',
			margin: '0px 0px 10px 0px',
		},
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		sectionDivider: {
			backgroundColor: primaryColor,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		addInputButton: {
			borderRadius: '100px',
			marginTop: 20,
			marginBottom: 30,
			textTransform: 'uppercase',
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		helper: {
			borderLeft: `2px solid ${theme.palette.divider}`,
			padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
			margin: '20px 0px',
			fontSize: 14,
			color: '#666',
		},
	};
};
const formFields = {
	name: '',
	shortName: '',
	note: '',
	address: '',
	deliveryEmails: [''],
	scheduleEmails: [''],
	billingQuickbooksVendorId: '',
	contacts: [
		{
			name: '',
			title: '',
			officePhoneNumber: '',
			mobilePhoneNumber: '',
			email: '',
			note: '',
		},
	],
};

class SaveSupplier extends Component {
	constructor(props) {
		super(props);
		const supplierId = _.get(this.props, ['match', 'params', 'supplierId']);

		this.state = {
			supplierId: supplierId ? parseInt(supplierId, 10) : undefined,
			isUpdate: supplierId,
		};
		this.state = _.merge(this.state, formFields);
	}

	componentDidMount() {
		//- Only used for updates
		const { supplier, getSupplier } = this.props;
		const { isUpdate, supplierId } = this.state;

		if (!isUpdate) {
			return;
		}

		if (!supplier) {
			getSupplier({ params: { supplierIds: [supplierId] } });
		} else {
			this.updateDefaultValues(this.props);
		}
	}

	updateDefaultValues(props) {
		if (!props.supplier) {
			return;
		}
		this.setState(props.supplier);

		if (_.isNull(props.supplier.billingQuickbooksVendorId)) {
			this.setState({ billingQuickbooksVendorId: '' });
		}
	}

	componentDidUpdate(prevProps) {
		if (_.isUndefined(prevProps.supplier) && this.props.supplier) {
			this.updateDefaultValues(this.props);
		}
	}

	handleSave = () => {
		const params = {};
		[
			'name',
			'shortName',
			'address',
			'note',
			'deliveryEmails',
			'scheduleEmails',
			'contacts',
			'billingQuickbooksVendorId',
		].forEach((fieldName) => {
			params[fieldName] = this.state[fieldName];
		});

		if (this.state.isUpdate) {
			params.supplierId = this.state.supplierId;
			this.props.updateSupplier({ params });
		} else {
			this.props.addSupplier({ params });
		}
	};

	onChange = (event, fieldName, index, attr) => {
		if (!_.isNumber(index)) {
			this.setState({ [fieldName]: event.target.value });
		} else {
			const inputs = this.state[fieldName].slice();
			if (attr) {
				inputs[index][attr] = event.target.value;
			} else {
				inputs[index] = event.target.value;
			}
			this.setState({ [fieldName]: inputs });
		}
	};

	handlePureChange = _.debounce((value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}
		this.setState(newState);
	});

	getInputProps = (path, defaultValue) => {
		return {
			path,
			value: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.handlePureChange,
			md: 6,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	addInput = (arrayName) => {
		const val = _.cloneDeep(formFields[arrayName]);
		this.setState({ [arrayName]: this.state[arrayName].concat(val) });
	};

	removeInput = (arrayName, index) => {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		this.setState({ [arrayName]: inputs });
	};

	render() {
		const { classes, supplier } = this.props;
		const { isUpdate, contacts } = this.state;

		if (isUpdate && !supplier) {
			return <div>Fetching supplier information...</div>;
		}

		const verb = isUpdate ? 'Update' : 'Add';
		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography variant="h5" align="left" gutterBottom>
								{verb} Supplier
							</Typography>
						</Grid>
					</Grid>
					<Paper className={classes.paper}>
						<div className={classes.sectionHeader}>Supplier Info</div>

						<FMPTextField
							name={'name'}
							label={'Supplier Name'}
							controller={this}
							helpText={'(displayed in delivery orders)'}
						/>

						<FMPTextField
							name={'shortName'}
							label={'Supplier Short Name'}
							controller={this}
							helpText={'(used on excise report)'}
						/>

						<FMPTextField name={'address'} label={'Supplier Address'} controller={this} />

						<FMPTextField name={'note'} label={'Notes'} controller={this} multiline={3} />

						<div className={classes.sectionHeader}>Delivery Emails</div>
						<div className={classes.note}>
							* Only used when <i>Email supplier copy of delivery </i>
							is picked for this supplier on a terminal
						</div>
						{this.renderDeliveryEmails()}

						{this.renderScheduleEmails()}

						<Contacts contacts={contacts} controller={this} />

						<div className={classes.sectionHeader}>Link to Quickbooks</div>
						<FMPQuickbooksVendorSelect
							{...this.getInputProps(`billingQuickbooksVendorId`, '')}
							label={'Quickbooks customer for billing'}
						/>

						<div style={{ textAlign: 'right' }}>
							<Button
								variant="contained"
								color="primary"
								className={classes.submitButton}
								onClick={this.handleSave}
							>
								{verb} Supplier
							</Button>
						</div>
					</Paper>
				</Grid>
			</Grid>
		);
	}

	renderDeliveryEmails() {
		const { classes } = this.props;
		const { deliveryEmails } = this.state;

		return (
			<div>
				{deliveryEmails.map((email, i) => {
					return (
						<Grid key={i} container spacing={3}>
							<Grid item xs={11} md={5}>
								<TextField
									value={email}
									onChange={(event) => this.onChange(event, 'deliveryEmails', i)}
									label={`Email ${i + 1}`}
									fullWidth
								/>
							</Grid>
							<Grid item xs={1}>
								{deliveryEmails.length >= 2 && (
									<IconButton
										color="primary"
										className={classes.button}
										onClick={() => this.removeInput('deliveryEmails', i)}
									>
										<DeleteIcon />
									</IconButton>
								)}
							</Grid>
						</Grid>
					);
				})}

				<Button
					variant="contained"
					className={classes.addInputButton}
					onClick={() => this.addInput('deliveryEmails')}
				>
					ADD ANOTHER DELIVERY EMAIL
				</Button>
			</div>
		);
	}

	renderScheduleEmails() {
		const { classes } = this.props;
		const { scheduleEmails } = this.state;

		return (
			<>
				<div className={classes.sectionHeader}>Schedule Emails</div>
				<div className={classes.helper}>
					Add any emails that you want to receive a 30 day out delivery schedule of all station and
					bulk deliveries. This will be delivered twice a day, once at 10am and once at 4am.
				</div>

				<div>
					{scheduleEmails.map((email, i) => {
						return (
							<Grid key={i} container spacing={3} alignItems="flex-end">
								<Grid item xs={11} md={5}>
									<TextField
										value={email}
										onChange={(event) => this.onChange(event, 'scheduleEmails', i)}
										label={`Email ${i + 1}`}
										fullWidth
									/>
								</Grid>
								<Grid item xs={1}>
									<IconButton
										color="primary"
										className={classes.button}
										onClick={() => this.removeInput('scheduleEmails', i)}
									>
										<DeleteIcon />
									</IconButton>
								</Grid>
							</Grid>
						);
					})}

					<Button
						variant="contained"
						className={classes.addInputButton}
						onClick={() => this.addInput('scheduleEmails')}
					>
						ADD SCHEDULE EMAIL
					</Button>
				</div>
			</>
		);
	}
}

SaveSupplier.propTypes = {
	classes: PropTypes.object.isRequired,
	getSupplier: PropTypes.func.isRequired,
	addSupplier: PropTypes.func.isRequired,
	updateSupplier: PropTypes.func.isRequired,
	supplier: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles), SupplierContainer])(SaveSupplier);
